import React from 'react';

const SectionHeader = ({text}) =>
{
  return <h3 className="utv-section-header">{text}</h3>;
}

export default SectionHeader;
